import { create } from 'zustand';

interface IMessageModalStore {
  isModalOpen: boolean;
  navigate: (() => void) | null; // 페이지 이동을 처리할 함수
  openModal: (navigate: () => void) => void; // 함수를 인자로 받음
  closeModal: () => void;
  clearNavigate: () => void;
}

export const useMessageModalStore = create<IMessageModalStore>(set => ({
  isModalOpen: false,
  navigate: null,
  openModal: (navigate: () => void) => set({ isModalOpen: true, navigate }),
  closeModal: () => set({ isModalOpen: false }),
  clearNavigate: () => set({ navigate: null }),
}));

// 작성 중인 글 상태 관리
interface IsDifferenceState {
  isDifference: boolean;
  setIsDifference: (isDifference: boolean) => void;
}

export const useIsDifferenceStore = create<IsDifferenceState>(set => ({
  isDifference: false, // 작성 중인 글이 있는지 여부
  setIsDifference: isDraft => set({ isDifference: isDraft }), // 작성 중인 글이 있는지 여부를 설정
}));
